var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-container" },
    [
      _c(
        "el-card",
        {
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: 0 },
          },
        },
        [
          _c(
            "div",
            { staticClass: "padding-add" },
            [
              _c(
                "el-form",
                {
                  ref: "queryFormRef",
                  attrs: { model: _vm.queryParams, inline: "" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "盘库单号", prop: "checkNo" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.queryParams.checkNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "checkNo", $$v)
                          },
                          expression: "queryParams.checkNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "操作人", prop: "operator" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.queryParams.operator,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "operator", $$v)
                          },
                          expression: "queryParams.operator",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态", prop: "status" } },
                    [
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.queryParams.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "status", $$v)
                            },
                            expression: "queryParams.status",
                          },
                        },
                        _vm._l(_vm.statusOptions, function (v, k) {
                          return _c("el-option", {
                            key: "option_" + k,
                            attrs: { value: k, label: v },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onQuery },
                        },
                        [_vm._v("查询")]
                      ),
                      _c("el-button", { on: { click: _vm.onReset } }, [
                        _vm._v("重置"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        { staticClass: "box-card mt14" },
        [
          _c(
            "el-row",
            { staticClass: "mb16", attrs: { type: "flex", justify: "start" } },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["admin:stockCheck:save"],
                      expression: "['admin:stockCheck:save']",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.onCreate },
                },
                [_vm._v("创建盘库单")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                height: "calc(100vh - 430px)",
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "id",
                  label: "ID",
                  width: "90",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "checkNo", label: "盘库单号", width: "150" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: "状态",
                  width: "80",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: scope.row.status ? "primary" : "info",
                            },
                          },
                          [_vm._v(_vm._s(_vm.statusOptions[scope.row.status]))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "adminName", label: "操作人", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.adminName) +
                            " ( id: " +
                            _vm._s(scope.row.operator) +
                            " ) "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  align: "center",
                  width: "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.parseTime(scope.row.createTime)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "updateTime",
                  label: "更新时间",
                  align: "center",
                  width: "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.parseTime(scope.row.updateTime)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "completedAt",
                  label: "完成时间",
                  align: "center",
                  width: "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.completedAt === undefined ||
                        scope.row.completedAt === null
                          ? _c("span", { staticClass: "text-placeholder" }, [
                              _vm._v("/"),
                            ])
                          : _c("span", [
                              _vm._v(
                                _vm._s(_vm.parseTime(scope.row.completedAt))
                              ),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "remark", label: "备注", "min-width": "300" },
              }),
              _c("el-table-column", {
                attrs: { fixed: "right", label: "操作", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.onShowDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                        scope.row.status === 0
                          ? [
                              _c("el-divider", {
                                attrs: { direction: "vertical" },
                              }),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "hasPermi",
                                      rawName: "v-hasPermi",
                                      value: ["admin:stockCheck:update"],
                                      expression: "['admin:stockCheck:update']",
                                    },
                                  ],
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onFinish(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("完结")]
                              ),
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "mt16", attrs: { type: "flex", justify: "end" } },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [20, 40, 60, 80],
                  "page-size": _vm.queryParams.limit,
                  "current-page": _vm.queryParams.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.onSizeChange,
                  "current-change": _vm.onPageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("InventoryCountingEditor", {
        ref: "inventoryCountingEditorRef",
        on: { success: _vm.onUpdateSuccess },
      }),
      _c("InventoryCountingDetail", {
        ref: "inventoryCountingDetailRef",
        on: { succss: _vm.onUpdateSuccess },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }